import TileButton from 'components/atoms/TileButton';
import React, { useState } from 'react';
import PlanComparisonContainer from './PlanComparisonContainer';
const subHeader = '';

const Reports = () => {
    const subTileData = [{ label: 'Plan Comparison', key: 'plan_comparison', component: <PlanComparisonContainer /> }];
    const [selectedTile, setSelectedTile] = useState(subTileData[0]);
    return (
        <div className="relative">
            <h5 className={`font-xs m-0 font-normal text-fontGreyAlt mt-2`}>{subHeader} </h5>
            <div className="my-2 border-b border-borderGreyAlt"></div>
            <div className="absolute left-0 top-3">
                <TileButton
                    style={{ width: 'min-content' }}
                    data={subTileData}
                    activeKey={selectedTile.key}
                    onClick={(item: any) => {
                        setSelectedTile(item);
                    }}
                />
            </div>
            {selectedTile?.component}
        </div>
    );
};

export default Reports;
